import { combineReducers } from "redux";
import { reducer as layoutReducer } from "./layout";

export default combineReducers({
  layout: layoutReducer,
});
